module.exports = __webpack_public_path__ + "static/media/adobe.8c3b26e6.svg";